<div class="sensitivity-atb-view">
  <h1 class="satb-title">{{ 'WEB_RESULTS.EPIDEMIOLOGY.SENSITIVITY_ATB' | translate }}</h1>
  <div class="satb-date-range" *ngIf="dateRangeLabel">{{ dateRangeLabel }}</div>

  <p-message *ngIf="error" severity="error" [text]="error"></p-message>

  <section class="satb-section" *ngIf="patient">
    <afoone-patient-data [patient]="patient"></afoone-patient-data>
  </section>

  <div class="loading" *ngIf="loading">{{ 'WEB_RESULTS.EPIDEMIOLOGY.LOADING_DATA' | translate }}</div>

  <p-message
    *ngIf="!loading && !error && patient && pivot.columns.length === 0"
    severity="info"
    [text]="'WEB_RESULTS.EPIDEMIOLOGY.ATB_MATRIX_EMPTY' | translate"
  ></p-message>

  <ng-container *ngIf="!loading && !error && pivot.columns.length > 0">
    <section class="satb-toolbar">
      <div class="satb-filters">
        <div class="satb-filter-field">
          <label class="satb-filter-label" for="satb-filter-micro">{{ 'WEB_RESULTS.EPIDEMIOLOGY.FILTER_MICROORGANISMS' | translate }}</label>
          <p-multiSelect
            inputId="satb-filter-micro"
            [options]="microbeOptions"
            [(ngModel)]="selectedMicrobes"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            display="chip"
            [placeholder]="'WEB_RESULTS.EPIDEMIOLOGY.FILTER_ALL' | translate"
            appendTo="body"
            panelStyleClass="satb-multiselect-overlay-panel"
            styleClass="satb-multiselect"
            (onChange)="onCrossFilterChange()"
          ></p-multiSelect>
        </div>

        <div class="satb-filter-field">
          <label class="satb-filter-label" for="satb-filter-material">{{ 'WEB_RESULTS.EPIDEMIOLOGY.FILTER_SAMPLE_TYPES' | translate }}</label>
          <p-multiSelect
            inputId="satb-filter-material"
            [options]="materialOptions"
            [(ngModel)]="selectedMaterials"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            display="chip"
            [placeholder]="'WEB_RESULTS.EPIDEMIOLOGY.FILTER_ALL' | translate"
            appendTo="body"
            panelStyleClass="satb-multiselect-overlay-panel"
            styleClass="satb-multiselect"
            (onChange)="onCrossFilterChange()"
          ></p-multiSelect>
        </div>

        <div class="satb-filter-field">
          <label class="satb-filter-label" for="satb-atb-filter">{{ 'WEB_RESULTS.EPIDEMIOLOGY.FILTER_ATB_NAME' | translate }}</label>
          <input
            id="satb-atb-filter"
            pInputText
            type="text"
            class="satb-atb-name-input"
            [(ngModel)]="atbRowFilter"
            [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.FILTER_ATB_NAME' | translate"
          />
        </div>
      </div>

      <p-button
        styleClass="satb-export-btn"
        [label]="'WEB_RESULTS.EPIDEMIOLOGY.EXPORT_CSV' | translate"
        icon="pi pi-download"
        (onClick)="exportCsv()"
        [disabled]="!canExport"
      ></p-button>
    </section>

    <p-message
      *ngIf="visibleColumns.length === 0"
      severity="warn"
      [text]="'WEB_RESULTS.EPIDEMIOLOGY.FILTER_NO_COLUMNS' | translate"
    ></p-message>

    <div class="satb-matrix-wrapper" *ngIf="visibleColumns.length > 0">
      <table
        class="satb-matrix"
        [style.--satb-data-cols]="satbDataColsVar"
      >
        <thead>
          <tr>
            <th scope="col" class="satb-corner">{{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ATB' | translate }}</th>
            <th scope="col" *ngFor="let col of visibleColumns" class="satb-col-head satb-col-data">
              <div class="satb-col-head-inner">
                <span *ngFor="let line of columnHeaderLines(col)" class="satb-col-line">{{ line }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let atb of visibleCatalogRows">
            <th scope="row" class="satb-row-head">
              <span class="satb-cell-text" [attr.title]="atb.atbName">{{ atb.atbName }}</span>
            </th>
            <td
              *ngFor="let col of visibleColumns"
              class="satb-cell satb-col-data"
              [ngStyle]="{
                'background-color': cellState(col.requisCol, atb.testRow).backGroundColor || 'transparent'
              }"
            >
              <span class="satb-cell-text satb-result-text">{{ cellState(col.requisCol, atb.testRow).result }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
